/**
 * Avis Judge.me sur téléphone : seuls les premiers avis sont visibles, les autres
 * (et le bouton « Charger plus » de Judge.me) apparaissent au clic sur « Voir plus d'avis ».
 * Nombre et libellé : Réglages du thème > POP · Avis clients (attributs data- du script).
 * Judge.me redessine la liste (tri, onglets, pages) : un observateur réapplique le pliage.
 */
(() => {
  const script = document.currentScript;
  const visibles = parseInt(script?.dataset.visibles || '3', 10);
  const libelle = script?.dataset.libelle || '';
  if (!libelle || !(visibles > 0)) return;

  const replier = (widget) => {
    const liste = widget.querySelector('.jdgm-rev-widg__reviews');
    if (!liste) return;
    const avis = [...liste.querySelectorAll(':scope > .jdgm-rev')];
    const replie = !widget.classList.contains('pop-rev-ouvert') && avis.length > visibles;
    widget.classList.toggle('pop-rev-replie', replie);
    avis.forEach((a, i) => a.classList.toggle('pop-rev-cache', replie && i >= visibles));

    let bouton = widget.querySelector('.pop-rev-plus');
    if (replie && !bouton) {
      bouton = document.createElement('button');
      bouton.type = 'button';
      bouton.className = 'pop-rev-plus';
      bouton.textContent = libelle;
      bouton.addEventListener('click', () => {
        widget.classList.add('pop-rev-ouvert');
        bouton.remove();
        replier(widget);
      });
      liste.after(bouton);
    } else if (!replie && bouton) {
      bouton.remove();
    }
  };

  const suivre = (widget) => {
    if (widget.dataset.popRev) return;
    widget.dataset.popRev = '1';
    replier(widget);
    new MutationObserver(() => replier(widget)).observe(widget, { childList: true, subtree: true });
  };

  const chercher = () => document.querySelectorAll('.jdgm-rev-widg').forEach(suivre);
  chercher();
  new MutationObserver(chercher).observe(document.body, { childList: true, subtree: true });
})();
